import httpClient from './httpClient';

export const NAVIGATION_ITEM_ENDPOINT = '/backoffice/categories/navigation-item';

export const getNavigationItemsAPI = (params = {}) => httpClient.get(NAVIGATION_ITEM_ENDPOINT, { params });
export const getNavigationItemAPI = (id) => httpClient.get(`${NAVIGATION_ITEM_ENDPOINT}/${id}`);
export const postNavigationItemAPI = (body = {}) => httpClient.post(NAVIGATION_ITEM_ENDPOINT, body);
export const updateNavigationItemAPI = (id, body = {}) => httpClient.put(`${NAVIGATION_ITEM_ENDPOINT}/${id}`, body);
export const deleteNavigationItemAPI = (id) => httpClient.delete(`${NAVIGATION_ITEM_ENDPOINT}/${id}`);